<template>
  <div class="solar-scale-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>1 AU ≈ 1.5e8 km | 真实比例演示$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <radialGradient id="sun-grad">
                <stop offset="0%" stop-color="#fff700" />
                <stop offset="100%" stop-color="#ff4757" />
             </radialGradient>
          </defs>

          <!-- The Sun (Partial) -->
          <circle cx="0" cy="120" :r="sunRadius" fill="url(#sun-grad)" opacity="0.8" />
          <text x="10" y="125" fill="#fff" font-size="10">SUN</text>

          <!-- Planets -->
          <g v-for="(p, i) in planets" :key="i" :transform="`translate(${calcX(p.dist)}, 120)`">
             <circle :r="p.size * sizeFactor" :fill="p.color" />
             <text y="30" text-anchor="middle" fill="#888" font-size="6">{{ p.name }}</text>
          </g>

          <!-- Axis -->
          <line x1="0" y1="120" x2="400" y2="120" stroke="rgba(255,255,255,0.05)" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>显示比例: {{ isLog ? '对数刻度' : '真实比例' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-checkbox v-model="isLog">切换为对数刻度（否则外行星在远处看不到）</el-checkbox>
          </div>
          <div class="row">
             <label>行星大小放大倍率</label>
             <el-slider v-model="sizeFactor" :min="1" :max="20" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>太阳系的空间尺度极度不均匀。如果按真实位置比例，当水星在屏幕左侧时，海王星将在数百公里之外。物理学中常使用**对数坐标**来在有限范围内展示跨越数个数量级的数据。此外，行星大小与太阳相比也极其微小，这揭示了宇宙空间的“空旷”本质。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolarSystemScaleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      isLog: true,
      sizeFactor: 5,
      sunRadius: 40,
      planets: [
        { name: '水星', dist: 0.39, size: 2.4, color: '#aaa' },
        { name: '金星', dist: 0.72, size: 6.0, color: '#eab' },
        { name: '地球', dist: 1.00, size: 6.3, color: '#2ed573' },
        { name: '火星', dist: 1.52, size: 3.4, color: '#ff4757' },
        { name: '木星', dist: 5.20, size: 15.0, color: '#dca' },
        { name: '土星', dist: 9.54, size: 12.0, color: '#ffcc00' }
      ]
    }
  },
  methods: {
    calcX(dist) {
      if (this.isLog) {
         // Log scale to fit all
         return 60 + Math.log(dist + 0.1) * 80 + 80;
      } else {
         // Linear scale (most planets will be off screen or crowded)
         return 50 + dist * 30;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.solar-scale-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
